/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Admin_Resources_Images_Input_Count_AccessibleInputs */

const en_admin_resources_images_input_count_accessible = /** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of ${i?.max} images`)
};

const de_admin_resources_images_input_count_accessible = /** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} von ${i?.max} Bildern`)
};

const es_admin_resources_images_input_count_accessible = /** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de ${i?.max} imágenes`)
};

const fr_admin_resources_images_input_count_accessible = /** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sur ${i?.max} images`)
};

const nl_admin_resources_images_input_count_accessible = /** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} van ${i?.max} afbeeldingen`)
};

/** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */
const it_admin_resources_images_input_count_accessible = en_admin_resources_images_input_count_accessible;

/** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */
const pt_br2_admin_resources_images_input_count_accessible = en_admin_resources_images_input_count_accessible;

/** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */
const pl_admin_resources_images_input_count_accessible = en_admin_resources_images_input_count_accessible;

/** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */
const hu_admin_resources_images_input_count_accessible = en_admin_resources_images_input_count_accessible;

/** @type {(inputs: Admin_Resources_Images_Input_Count_AccessibleInputs) => LocalizedString} */
const ro_admin_resources_images_input_count_accessible = en_admin_resources_images_input_count_accessible;

/**
* | output |
* | --- |
* | "{count} of {max} images" |
*
* @param {Admin_Resources_Images_Input_Count_AccessibleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_images_input_count_accessible = /** @type {((inputs: Admin_Resources_Images_Input_Count_AccessibleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Images_Input_Count_AccessibleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_images_input_count_accessible(inputs)
	if (locale === "de") return de_admin_resources_images_input_count_accessible(inputs)
	if (locale === "es") return es_admin_resources_images_input_count_accessible(inputs)
	if (locale === "fr") return fr_admin_resources_images_input_count_accessible(inputs)
	if (locale === "nl") return nl_admin_resources_images_input_count_accessible(inputs)
	if (locale === "it") return it_admin_resources_images_input_count_accessible(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_images_input_count_accessible(inputs)
	if (locale === "pl") return pl_admin_resources_images_input_count_accessible(inputs)
	if (locale === "hu") return hu_admin_resources_images_input_count_accessible(inputs)
	return ro_admin_resources_images_input_count_accessible(inputs)
});
export { admin_resources_images_input_count_accessible as "admin.resources.images_input.count_accessible" }